import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { prepareValues } from '../ProjectAdminsPicker/utils';
import Select from '../../../../../common/components/Select';

const SelectDropdown = ({ options, selectTitle, value, changeHandler }) => {
  const [option, setOption] = useState(options.find(o => o.value === value));

  const handleChange = newOption => {
    setOption(newOption);
    changeHandler(newOption.value);
  };

  return (
    <div className="questionsInfo">
      <h4>{selectTitle}</h4>
      <Select
        className="questionsInfo-select"
        value={option}
        options={options}
        onChange={handleChange}
      />
    </div>
  );
};

export default SelectDropdown;



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Workdesk/components/ProjectFeedback/SelectDropDowns.js